<template>
    <div class="tag-input">
        <input type="hidden" v-for="tag in currentTags" :name="name" :value="tag">

        <app-input
            v-bind="{...$props, ...{name: undefined}}"
            v-model="inputString"
            @onEnter.prevent="add(inputString)"
            @focus="onFocus"
            @focusout="onFocusOut">
        </app-input>

        <ul class="tag-input-selected" v-show="currentTags.length">
            <li v-for="(tag, index) in currentTags" @click="remove(index)">
                {{ tag }}
                <ion-icon name="close-outline"></ion-icon>
            </li>
        </ul>
        <dropdown ref="dropdown" class="dropdown-tags">
            <template v-slot:trigger>
            </template>
            <template v-slot:body>
                <ul class="tag-input-autocomplete" v-show="matches.length">
                    <li v-for="(tag) in matches" @click="add(tag)">
                        {{ tag }}
                    </li>
                </ul>
            </template>
        </dropdown>
    </div>
</template>

<script>
    export default {
        props: {
            label: String,
            error: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            autocomplete: {
                type: String,
                default: 'off'
            },
            name: String,
            isRequired: {
                type: Boolean,
                default: false
            },
            is_disabled: {
                type: Boolean,
                default: false
            },
            id: String,
            iconState: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: 'text'
            },
            help_link: {
                type: String,
                default: ''
            },
            availableTags: {
                type: Array,
                default() {
                    return [];
                }
            },
            value: {
                type: Array,
                default() {
                    return [];
                }
            },
        },
        data() {
            return {
                inputString: '',
                currentTags: [],
            }
        },
        mounted() {
            if (this.value.length)
                this.currentTags = [...this.value]
        },
        methods: {
            add(tag) {
                if (tag) {
                    if (!this.currentTags.includes(tag)) {
                        this.currentTags.push(tag);
                    }

                    this.inputString = '';
                }

            },
            remove(index) {
                this.currentTags.splice(index, 1);
            },
            onFocus(e) {
                let $dropdown = this.$refs.dropdown
                $dropdown.$data.isOpened = true
            },
            onFocusOut(e) {
                let $dropdown = this.$refs.dropdown
                setTimeout(function () {
                    $dropdown.$data.isOpened = false
                }, 200)
            }
        },
        computed: {
            matches() {
                return this.availableTags.filter(tag => {
                    return tag.includes(this.inputString) && !this.currentTags.includes(tag);
                });
            }
        },
    }
</script>

<style lang="scss">
    .dropdown-tags .dropdown-menu {
        margin-top: -5px !important;

        &.dropdown-bottom {
            &::before {
                border-bottom-color: #ECEFF9 !important;
            }
        }

        .dropdown-body {
            padding: 5px 10px;

            ul li {
                padding: 2px 0;
                cursor: pointer;
            }
        }
    }
</style>
